import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import FormInput from 'app/shared-components/formComponents/FormInput';
import { useStore } from 'zustand';
import { kurvFormSlice } from 'app/store/kurvFormSlice';
import { IKurvSalesAndTransactionsFormValues, kurvSalesAndTransactionsSchema } from './validation';

interface IProps {
  index: number;
  setNextForm: () => void;
  setPrevForm: () => void;
}

const KurvSalesAndTransactionsForm = ({ setNextForm, setPrevForm, index }: IProps) => {
  const store = useStore(kurvFormSlice);

  const methods = useForm<IKurvSalesAndTransactionsFormValues>({
    mode: 'onChange',
    values: store.salesAndTransactions,
    resolver: yupResolver(kurvSalesAndTransactionsSchema),
  });
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form
        className="flex flex-col flex-1 justify-between mt-16"
        onSubmit={handleSubmit((d) => {
          store.setSalesAndTransactions(d);
          setNextForm();
        })}
      >
        <div className="flex justify-between gap-[26px]">
          <div className="flex-1">
            <Typography className="font-500 tracking-tight leading-tight h-[35px]">
              Types of Sales (Total must be 100%):
            </Typography>
            <FormInput
              className="mt-20"
              id="onSite"
              label="On Premise Sales*"
              errorMessage={errors.onSite?.message}
              control={control}
              variant="outlined"
              fullWidth
            />
            <FormInput
              className="mt-20"
              id="offSite"
              label="Of Premise Sales*"
              errorMessage={errors.offSite?.message}
              control={control}
              variant="outlined"
              fullWidth
            />
            <FormInput
              className="mt-20"
              id="mailOrder"
              label="Mail order*"
              errorMessage={errors.mailOrder?.message}
              control={control}
              variant="outlined"
              fullWidth
            />
            <FormInput
              className="mt-20"
              id="telephoneOrder"
              label="Telephone Order*"
              errorMessage={errors.telephoneOrder?.message}
              control={control}
              variant="outlined"
              fullWidth
            />
            <FormInput
              className="mt-20"
              id="internet"
              label="Internet*"
              errorMessage={errors.internet?.message}
              control={control}
              variant="outlined"
              fullWidth
            />
          </div>
          <div className="flex-1">
            <Typography className="font-500 tracking-tight leading-tight h-[35px]">
              Origination of Transactions (Total must be 100%):
            </Typography>
            <FormInput
              className="mt-20"
              id="swiped"
              label="Sales Swiped* "
              errorMessage={errors.swiped?.message}
              control={control}
              variant="outlined"
              fullWidth
            />
            <FormInput
              className="mt-20"
              id="keyed"
              label="Sales Keyed*"
              errorMessage={errors.keyed?.message}
              control={control}
              variant="outlined"
              fullWidth
            />
          </div>
        </div>
        <div className="flex justify-end gap-[10px]">
          <Button
            variant="text"
            color="secondary"
            className="mt-16 text-[#111827] disabled:text-dark-primary disabled:text-opacity-60"
            aria-label="Back"
            type="button"
            onClick={setPrevForm}
            size="large"
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="secondary"
            className="mt-16 text-white bg-blue-primary disabled:text-dark-primary disabled:bg-gray-400 disabled:text-opacity-60"
            aria-label="Next step"
            type="submit"
            size="large"
            disabled={!isValid}
          >
            Next step
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default KurvSalesAndTransactionsForm;
